import {
  AllItem,
  AllPortfolioIcon,
  DownChevronIcon,
  Item,
  ProductItemImage,
  ProductItemImageWrapper,
  SelectBoxWrapper,
  SelectItemWrapper,
} from 'pages/portfolio/styled'
import { getProductByAddress } from 'indices-list'
import React, { Fragment } from 'react'
import { SelectBoxInterface, SelectItem } from 'pages/portfolio/interface'

import { ProductSelectWrapper } from '../../styled'
import { useClickOutsideComponents } from 'hooks/use-click-outside-component'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'
import { ALL_PORTFOLIO_ID } from 'app-constants'
import { UserProductHistory } from 'services/query-v2/users/history/model'
import { getAssetIconBySymbol } from 'abis/set/asset-icons'
import { SeparatorLine } from 'components/index-cover/styled'

const buildAllProductSelectItem = () => {
  return {
    id: ALL_PORTFOLIO_ID,
    name: 'All portfolio',
    currentValue: '0',
    image: <AllPortfolioIcon />,
  }
}
const pickItem = (id: string): SelectItem => {
  if (id === ALL_PORTFOLIO_ID) {
    return buildAllProductSelectItem()
  }
  const product = getProductByAddress(id)
  const productSymbol = product.symbol === 'ZTI' ? 'ZCX' : product.symbol
  return {
    id: product.address,
    name: product.longName,
    currentValue: '0',
    image: (
      <ProductItemImageWrapper>
        <ProductItemImage src={getAssetIconBySymbol(productSymbol.toUpperCase())} />
      </ProductItemImageWrapper>
    ),
  }
}
const getAllProducts = (productHistory: UserProductHistory[]) => [
  buildAllProductSelectItem(),
  ...productHistory.map(toSelectItem),
]
const toSelectItem = (item: UserProductHistory) => pickItem(item.id)
const withoutSelection = (selected: SelectItem) => (item: SelectItem) => item.id !== selected.id

export const SelectBoxDropdown: React.FC<SelectBoxInterface> = ({ dispatch, productHistory }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [selectedProduct, setSelectedProduct] = React.useState<SelectItem>(
    pickItem(ALL_PORTFOLIO_ID),
  )
  const [itemsToShow] = React.useState<SelectItem[]>(getAllProducts(productHistory))
  const toggleOpen = () => setIsOpen(!isOpen)
  const { run, currentStep, setCurrentStep } = useTourGuide()
  const { getReference } = useClickOutsideComponents(() => {
    if (run && currentStep === 16) return
    setIsOpen(false)
  })
  const dropdownReference = getReference()

  React.useEffect(() => {
    if (!run) return

    if (!isOpen && currentStep === 16) {
      setIsOpen(true)
    }
  }, [currentStep, run, isOpen])

  React.useEffect(() => {
    if (run && currentStep === 16) {
      setSelectedProduct(pickItem(ALL_PORTFOLIO_ID))
      dispatch({ type: 'set_selected_portfolio', payload: ALL_PORTFOLIO_ID })
    }
  }, [currentStep])

  const handleClick = (item: SelectItem) => {
    if (run && currentStep === 16) {
      setSelectedProduct(item)
      dispatch({ type: 'set_selected_portfolio', payload: item.id })
      setTimeout(() => {
        setCurrentStep(17)
        setIsOpen(false)
      }, 120)
    }
    dispatch({ type: 'set_selected_portfolio', payload: item.id })
    setIsOpen(false)
    return setSelectedProduct(item)
  }
  const maybeShowList = () => {
    if (isOpen) {
      return (
        <ProductSelectWrapper>
          {itemsToShow.filter(withoutSelection(selectedProduct)).map((item) => (
            <Fragment key={`${item.id}-${item.name}`}>
              <SeparatorLine style={{ margin: '0 20px 20px 20px' }} />
              <Item key={item.name} onClick={() => handleClick(item)}>
                {item.image}
                <span>{item.name}</span>
              </Item>
            </Fragment>
          ))}
        </ProductSelectWrapper>
      )
    }
    return null
  }
  return (
    <SelectBoxWrapper id="tour-portfolio-select-box" ref={dropdownReference}>
      <SelectItemWrapper isOpen={isOpen}>
        <AllItem onClick={toggleOpen}>
          {selectedProduct?.image}
          <span>{selectedProduct?.name}</span>
          <DownChevronIcon open={isOpen} />
        </AllItem>
        {maybeShowList()}
      </SelectItemWrapper>
    </SelectBoxWrapper>
  )
}
